import React from "react";
import PropTypes from "prop-types";
import { Column } from "primereact/column";
import { RichDataTable } from "../../../../components/table/RichDataTable";
import {
  PageHeight40,
  PageTitle,
  createSortByAttr,
  toUIDate,
} from "../../../../components/Utils";
import { FormMenu } from "../../../../components/Buttons";
import ItemListManager from "../../../../components/ItemListManager";
import ADWorkplaceTaskMenu from "../../components/itConnections/ADWorkplaceTaskMenu";

import { connect } from "react-redux";
import {
  setSelectedADWorkplaceTasks,
  exportADWorkplaceTasks,
  filterADWorkplaceTasks,
  closeADWorkplaceTasks,
  closeConnectionTask,
  deleteConnectionTask,
} from "../../actions";
import { columnStyle, filterTasksByTaskType, isDeletionTask, renderNgumUserIDColumn, renderRequesterColumn, renderUserNameColumn, actionColumnStyle } from "../../components/Utils";
import ADWorkplaceTaskForm from "../../components/itConnections/ADWorkplaceTaskForm";

const CONNECTION_TYPE = "VBG";

const mapStateToProps = (state) => {
  return {
    isLoading: state.task.loading,
    data: state.task.adWorkplaceTasks,
    selection: state.task.selectedADWorkplaceTasks,
    connectionTaskType: state.task.currentADWorkplaceType,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setSelection: (...args) => dispatch(setSelectedADWorkplaceTasks(...args)),
  exportTaskList: (...args) => dispatch(exportADWorkplaceTasks(...args)),
  closeTaskList: (...args) => dispatch(closeADWorkplaceTasks(...args)),
  filterConnections: (...args) => dispatch(filterADWorkplaceTasks(...args)),
  closeTask: (...args) => dispatch(closeConnectionTask(...args)),
  deleteTask: (...args) => dispatch(deleteConnectionTask(...args)),
});

function ADWorkplaceTaskList({
  className = "",
  rows = 10,
  isLoading,
  data,
  selection,
  setSelection,
  exportTaskList,
  closeTaskList,
  closeTask,
  deleteTask,
  filterConnections,
  connectionTaskType,
}) {
  const onClose = React.useCallback(
    (task, onHide) => {
      if (!task) return;
      closeTask({ connectionType: CONNECTION_TYPE, task }, onHide);
    },
    [closeTask],
  );

  const onDelete = React.useCallback(
    (task) => {
      deleteTask({ connectionType: CONNECTION_TYPE, task });
    },
    [deleteTask],
  );

  const isDeleting = isDeletionTask(connectionTaskType);

  const renderItemTable = React.useCallback(
    (items, actionTemplate) => {
      const taskItems = items
        .map((item) => {
          if (!item.user) {
            console.log(
              "ADWorkplaceTaskList.renderItemTable() item.user is empty",
              item,
            );
          }
          return {
            ...item,
            user: (item.user || "").split(",").join(" "),
            requester: `${item.requester || ""}`.split(",").join(" "),
            requestDateUI: toUIDate(
              item.request_date,
              "YYYY-MM-DDTHH:mm:ss:SSSZ",
            ),
            requestDate: toUIDate(
              item.request_date,
              "YYYY-MM-DDTHH:mm:ss:SSSZ",
              "YYYY.MM.DD",
            ),
            userInCharge: `${item.userInCharge || ""}`.split(",").join(" "),
          };
        })
        .sort(createSortByAttr("request_date", true, true));
      return (
        <RichDataTable
          paginator
          paginatorLeftProps={{
            emptyText: "Keine Einträge",
            itemName: "Eintrag",
            itemNamePlural: "Einträge"
          }}
          data={taskItems}
          rows={rows}
          selection={selection}
          setSelection={setSelection}
          removableSort
          sortMode="multiple"
          isLoading={isLoading}
          connectionTaskType={connectionTaskType}
        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column
            field="parentCompanyName"
            header="Vertragspartner"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle }}
          />
          <Column
            field="user"
            header="Mitarbeiter"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle }}
            body={renderUserNameColumn}
          />
          <Column
            field="ngumUserId"
            header="nGUM UserID"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle }}
            body={renderNgumUserIDColumn}
          />
          <Column
            field="requester"
            header="Beantrager"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle, width: "12em" }}
            body={renderRequesterColumn}
          />
          <Column
            field="requestDate"
            header="Erstelldatum"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle, width: "10em", textAlign: "center" }}
            body={(item) => item.requestDateUI}
          />
          <Column
            field="status"
            header="Status"
            sortable={taskItems.length > 1}
            filter // ={taskItems.length > rows}
            filterMatchMode="contains"
            style={{ ...columnStyle, width: "9em" }}
          />
          <Column
            body={actionTemplate}
            style={{ ...actionColumnStyle, textAlign: "center", width: "7em" }}
          />
        </RichDataTable>
      );
    },
    [rows, selection, setSelection, isLoading, connectionTaskType],
  );

  const renderItemForm = (item, onHide) => {
    const connection = item;
    return (
      <div>
        <ADWorkplaceTaskForm
          ref={(ref) => (this.form = ref)}
          model={connection}
        />
        <FormMenu
          className="margin-big-top w3-border-top pad-big"
          style={{
            marginLeft: "-1em",
            marginRight: "-1em",
            marginBottom: "-1em",
          }}
          onSave={() => onClose(connection, onHide)}
          onCancel={onHide}
          saveBtnName="closeADWorkplaceTaskBtn"
          saveBtnLabel={"Schließen"}
        />
      </div>
    );
  };

  const getItemFormTitle = (/* connection */) => {
    let title = "VBG - CSC Kennung schließen";
    if (isDeleting) {
      title = "VBG - CSC Kennungslöschung bestätigen";
    }
    return <h3 className="no-margin">{title}</h3>;
  };

  const title = (
    <PageTitle>
      <ADWorkplaceTaskMenu
        className="w3-right"
        selectedADWorkplaceTasks={selection}
        exportADWorkplaceTasks={exportTaskList}
        closeADWorkplaceTasks={closeTaskList}
        filterConnections={filterConnections}
        connectionTaskType={connectionTaskType}
        items={data}
      />
      <h3 className="no-margin">{"VBG - CSC Kennungen"}</h3>
    </PageTitle>
  );

  return (
    <PageHeight40 className={className}>
      <ItemListManager
        key={Math.random()}
        itemPanelStyle={{ width: "600px" }}
        title={title}
        addBtnHidden
        items={data.filter((item) =>
          filterTasksByTaskType(item, connectionTaskType),
        )}
        getItemFormTitle={getItemFormTitle}
        renderItemTable={renderItemTable}
        renderItemForm={renderItemForm}
        namePrefix={`${CONNECTION_TYPE}Connection`}
        // itemDeleteable
        deleteTitle={`VBG - CSC Kennung löschen`}
        getDeleteText={(_item) =>
          `Wollen Sie diese Aufgabe unwiderruflich löschen?`
        }
        onDelete={onDelete}
      />
    </PageHeight40>
  );
}

ADWorkplaceTaskList.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  data: PropTypes.array,
  selection: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportTaskList: PropTypes.func.isRequired,
  closeTaskList: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  closeTask: PropTypes.func.isRequired,
  rows: PropTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ADWorkplaceTaskList);
